export default __webpack_public_path__ + "static/media/acm_logo.b64ea826.svg";